/**
 * True on macOS, where the modifier this app calls Alt is printed as ⌥ on the key — «alt» on
 * Nordic keyboards, «option» on US ones. Keyboard hints have to name it the way the user's own
 * keyboard does.
 */
export const isMacPlatform = () => {
  const navigatorWithUaData = navigator as Navigator & { userAgentData?: { platform?: string } };
  return /mac/i.test(navigatorWithUaData.userAgentData?.platform ?? navigator.platform ?? "");
};

export const altKeyLabel = () => (isMacPlatform() ? "⌥" : "Alt");

type Modifiers = {
  altKey: boolean;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
};

// AltGr on a Nordic Windows layout arrives as Ctrl+Alt, so composing a character would otherwise fire every shortcut this guards.
export const isExactlyAlt = (event: Modifiers) =>
  event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

export const hasNoModifier = (event: Modifiers) =>
  !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
